import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/src/app/global-error.tsx");
